import React, { useEffect } from "react"
import { useNavigate } from "react-router-dom";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { Button, Checkbox, Divider, Grid, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, TextField, Typography } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import SendIcon from '@mui/icons-material/Send';
import { useProfileController } from "./context/profile-controller";
import { useProfileState } from "./context/profile-context";
import SaveIcon from '@mui/icons-material/Save';
import { useMask} from '@react-input/mask';


export const Profile = () => {
    const navigate = useNavigate();
    const { userProfileResponse, userUpdateProfileRequest, listCityResponse, listStateResponse } = useProfileState();
    const { getInit, handleOnChange, updateProfile, listCities } = useProfileController();
    useEffect(() => {
        (async () => {
            await getInit();
        })();
    }, []);

    useEffect(() => {
        (async () => {
            if (userUpdateProfileRequest?.stateId !== null && userUpdateProfileRequest?.stateId !== undefined) {
                await listCities();
            }
        })();
    }, [userUpdateProfileRequest?.stateId]);

    return (
        <React.Fragment>
            <Grid
                item
                lg={10}
                sm={10}
                xl={10}
            >
                <InputLabel>Nome</InputLabel>
                <OutlinedInput
                    fullWidth
                    autoComplete='off'
                    onChange={handleOnChange}
                    onBlur={handleOnChange}
                    inputProps={{ maxLength: 500 }}
                    size="small"
                    name="input-name"
                    defaultValue={userUpdateProfileRequest?.name}
                    value={userUpdateProfileRequest?.name}
                    error={userUpdateProfileRequest?.name === undefined || userUpdateProfileRequest?.name?.length === 0 ? true : false}
                />
            </Grid><Grid
                item
                lg={2}
                sm={2}
                xl={2}
            >
                <InputLabel>CPF</InputLabel>
           <OutlinedInput fullWidth
                                        defaultValue={userUpdateProfileRequest?.formattedDocument}
                                        value={userUpdateProfileRequest?.formattedDocument}
                                        error={userUpdateProfileRequest?.document === undefined || userUpdateProfileRequest?.document?.length === 0 ? true : false}
                                       name="input-document"
                                       id="input-document"
                                                size="small"
                                     onChange={handleOnChange}
                                     onBlur={handleOnChange} inputRef={useMask({ mask: '___.___.___-__', showMask:true,  replacement: '_' })}/> 
             
            </Grid>
            <Grid
                item
                lg={12}
                sm={12}
                xl={12}
            >
                <InputLabel>Email</InputLabel>
                <OutlinedInput
                    fullWidth
                    autoComplete='off'
                    disabled
                    inputProps={{ maxLength: 500 }}
                    size="small"
                    name="input-email"
                    defaultValue={userProfileResponse?.email}
                    value={userProfileResponse?.email}
                /></Grid>

            <Grid item
                lg={12}
                sm={12}
                xl={12}>
                <Typography variant="h6">Endereço</Typography>
                <Divider></Divider>
            </Grid>
            <Grid
                item
                lg={2}
                sm={2}
                xl={2}
            >
                <InputLabel>CEP</InputLabel>
                <OutlinedInput
                    fullWidth
                    autoComplete='off'

                    onChange={handleOnChange}
                    onBlur={handleOnChange}
                    inputProps={{ maxLength: 500 }}
                    size="small"
                    name="input-zipcode"
                    inputRef={useMask({ mask: '_____-___', showMask:true,  replacement: '_' })}
                    defaultValue={userUpdateProfileRequest?.formattedZipCode}
                    value={userUpdateProfileRequest?.formattedZipCode}
                /></Grid>
            <Grid
                item
                lg={6}
                sm={6}
                xl={6}
            >
                <InputLabel>Logradouro</InputLabel>
                <OutlinedInput
                    fullWidth
                    autoComplete='off'
                    onChange={handleOnChange}
                    onBlur={handleOnChange}
                    inputProps={{ maxLength: 500 }}
                    size="small"
                    name="input-street"
                    defaultValue={userProfileResponse?.street}
                    value={userProfileResponse?.street}
                    error={(userUpdateProfileRequest?.zipCode!==undefined && userUpdateProfileRequest?.zipCode!==null  && (userUpdateProfileRequest?.street === undefined || userUpdateProfileRequest?.street?.length === 0 ))  ? true : false}
                /></Grid>
                 <Grid
                item
                lg={2}
                sm={2}
                xl={2}
            >
                <InputLabel>Bairro</InputLabel>
                <OutlinedInput
                    fullWidth
                    autoComplete='off'
                    onChange={handleOnChange}
                    onBlur={handleOnChange}
                    inputProps={{ maxLength: 500 }}
                    size="small"
                    name="input-neighborhood"
                    defaultValue={userProfileResponse?.neighborhood}
                    value={userProfileResponse?.neighborhood}
                    error={(userUpdateProfileRequest?.zipCode!==undefined && userUpdateProfileRequest?.zipCode!==null  && (userUpdateProfileRequest?.neighborhood === undefined || userUpdateProfileRequest?.neighborhood?.length === 0 ))  ? true : false}
                /></Grid>
            <Grid
                item
                lg={2}
                sm={2}
                xl={2}
            >
                <InputLabel>Número</InputLabel>
                <OutlinedInput
                    fullWidth
                    autoComplete='off'
                    onChange={handleOnChange}
                    onBlur={handleOnChange}
                    inputProps={{ maxLength: 500 }}
                    size="small"
                    name="input-number"
                    defaultValue={userProfileResponse?.number}
                    value={userProfileResponse?.number}
                /></Grid>
            <Grid
                item
                lg={4}
                sm={4}
                xl={4}
            >
                <InputLabel>Complemento</InputLabel>
                <OutlinedInput
                    fullWidth
                    autoComplete='off'
                    onChange={handleOnChange}
                    onBlur={handleOnChange}
                    inputProps={{ maxLength: 500 }}
                    size="small"
                    name="input-complement"
                    defaultValue={userUpdateProfileRequest?.complement}
                    value={userUpdateProfileRequest?.complement}
                /></Grid>
            <Grid
                item
                lg={3}
                sm={3}
                xl={3}
            >
                <InputLabel>Ponto de Referencia</InputLabel>
                <OutlinedInput
                    fullWidth
                    autoComplete='off'
                    onChange={handleOnChange}
                    onBlur={handleOnChange}
                    inputProps={{ maxLength: 500 }}
                    size="small"
                    name="input-referencePoint"
                    defaultValue={userUpdateProfileRequest?.referencePoint}
                    value={userUpdateProfileRequest?.referencePoint}
                /></Grid>
            <Grid
                item
                lg={2}
                sm={2}
                xl={2}
            >
                <InputLabel>Estado</InputLabel>
                <Select
                    name="select-state"
                    size="small"
                    value={userUpdateProfileRequest?.stateId ?? ""}
                    onChange={handleOnChange} fullWidth
                    error={userUpdateProfileRequest?.zipCode!==undefined && userUpdateProfileRequest?.zipCode!==null  && (userUpdateProfileRequest?.stateId === undefined || userUpdateProfileRequest?.stateId === null )? true : false}
                >
                    {listStateResponse?.map((element, index) => {
                        return (
                            <MenuItem value={element.id} key={element.id}>{element.name}</MenuItem>
                        );
                    })}
                </Select>
            </Grid>
            <Grid
                item
                lg={3}
                sm={3}
                xl={3}
            >
                <InputLabel>Município</InputLabel>
                <Select
                    name="select-city"
                    size="small"
                    value={userUpdateProfileRequest?.cityId ?? ""}
                    onChange={handleOnChange} fullWidth
                    error={userUpdateProfileRequest?.zipCode!==undefined && userUpdateProfileRequest?.zipCode!==null  && (userUpdateProfileRequest?.cityId === undefined || userUpdateProfileRequest?.cityId === null )? true : false}
                >
                    {listCityResponse?.map((element, index) => {
                        return (
                            <MenuItem value={element.id} key={element.id}>{element.name}</MenuItem>
                        );
                    })}
                </Select>
            </Grid>
            <Grid item lg={12}
                    sm={12}
                    xl={12} sx={{
                        mt: 1,
                        display: 'flex',
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "flex-end"

                    }}>
                    <Button variant="contained" onClick={async () => {
                        await updateProfile();
                    }} endIcon={<SaveIcon />}>Salvar</Button>
                </Grid>
        </React.Fragment>
    )
}